import {RouteLocationRaw} from 'vue-router'
import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {buildActiveCallBreadcrumbs} from '@toolify/client/src/modules/call/functions/buildActiveCallBreadcrumbs'

export function getActiveCallRouteLocation(
  conversationType: ConversationType | null | undefined,
  conversationNotificationPayload: unknown,
): RouteLocationRaw | null {
  const breadcrumbs = buildActiveCallBreadcrumbs(conversationType, conversationNotificationPayload)
  for(let index = breadcrumbs.length - 1; index >= 0; index -= 1) {
    if(breadcrumbs[index].to) {
      return breadcrumbs[index].to
    }
  }
  return null
}
